<app-template>
  <ng-container *ngIf="activePanel() === 'Dashboard'; else statisticTpl">
    <div class="dashboard-container">
      <!-- Dashboard Header -->
      <mat-card class="dashboard-header-card mb-4" appearance="outlined">
        <mat-card-content class="p-4">
          <div class="row align-items-center g-3">
            <div class="col-12 col-md-8">
              <div class="d-flex align-items-center mb-2">
                <mat-icon class="welcome-icon me-2">waving_hand</mat-icon>
                <h2 class="dashboard-title mb-0">Welcome, {{ accountName() }}</h2>
              </div>
              <p class="text-muted mb-0 ms-5">Manage your society operations from here</p>
            </div>
            <div class="col-12 col-md-4 text-md-end">
              <div class="d-flex align-items-center gap-2 justify-content-end justify-content-md-end">
                <button
                  mat-icon-button
                  class="raise-request-icon-btn"
                  (click)="raiseRequests()"
                  matTooltip="Raise Request"
                  matTooltipPosition="below">
                  <mat-icon>add_alert</mat-icon>
                </button>
                <button
                  mat-raised-button
                  color="primary"
                  [class.active]="isRequestDashboardActive()"
                  (click)="selectPanel('Request Dashboard')"
                  class="request-dashboard-btn">
                  <mat-icon>dashboard</mat-icon>
                  <span class="ms-2">Request Dashboard</span>
                </button>
              </div>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-12">
              <mat-chip-set>
                <mat-chip class="role-chip">
                  <mat-icon>account_circle</mat-icon>
                  <span class="ms-2">{{ roleName() || 'Member' }}</span>
                </mat-chip>
              </mat-chip-set>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <!-- Loading State -->
      <div *ngIf="isLoading()" class="d-flex justify-content-center align-items-center py-5">
        <mat-spinner diameter="50"></mat-spinner>
        <span class="ms-3 text-muted">Loading dashboard...</span>
      </div>

      <!-- Error State -->
      <div *ngIf="error() && !isLoading()" class="mb-4">
        <mat-card appearance="outlined" class="border-warning">
          <mat-card-content class="p-3">
            <div class="d-flex align-items-center">
              <mat-icon color="warn" class="me-2">error_outline</mat-icon>
              <span class="text-warning">{{ error() }}</span>
            </div>
          </mat-card-content>
        </mat-card>
      </div>

      <!-- Dashboard Cards Grid -->
      <div class="row g-3" *ngIf="!isLoading()">
        <div 
          class="col-12 col-sm-6 col-md-4 col-lg-2" 
          *ngFor="let item of dashboardItems; trackBy: trackByItemId">
          <mat-card 
            class="dashboard-card h-100" 
            appearance="outlined"
            (click)="navigateToRoute(item.route)">
            <mat-card-content class="text-center p-3">
                <div class="icon-wrapper mb-2">
                  <mat-icon class="dashboard-icon">{{ item.icon }}</mat-icon>
                </div>
                <h5 class="card-title mb-1 fw-semibold">{{ item.title }}</h5>
                <p class="text-muted small mb-0">{{ item.description }}</p>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #statisticTpl>
    <app-admin-dashboard></app-admin-dashboard>
  </ng-template>
</app-template>
